'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

interface UnitContextType {
  unitId: string | null;
  unitName: string | null;
  loading: boolean;
  refreshUnit: () => Promise<void>;
}

const UnitContext = createContext<UnitContextType>({
  unitId: null,
  unitName: null,
  loading: true,
  refreshUnit: async () => {},
});

export const useUnit = () => useContext(UnitContext);

export const UnitProvider = ({ children }: { children: React.ReactNode }) => {
  const [unitId, setUnitId] = useState<string | null>(null);
  const [unitName, setUnitName] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchUnitInfo = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get('/api/unit-info');
      setUnitId(data.unitId);
      setUnitName(data.unitName);
    } catch (error) {
      console.error('Failed to fetch unit info:', error);
      // Fallback if needed, or leave as null
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnitInfo();
  }, []);

  return (
    <UnitContext.Provider value={{ unitId, unitName, loading, refreshUnit: fetchUnitInfo }}>
      {children}
    </UnitContext.Provider>
  );
};
